import React from "react";
import { IonText, IonIcon } from "@ionic/react";
import { sadOutline } from "ionicons/icons";

const Empty = (props) => {
  const { title, subTitle, loading } = props;
  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        background: "#ffffff",
        flexDirection: "column",
        padding: "0 20px",
      }}
    >
      {loading ? null : (
        <>
          <IonIcon icon={sadOutline} style={{ fontSize: "100px" }} />
          <IonText>
            <h2 style={{ textAlign: "center" }}>{title}</h2>
            <p style={{ textAlign: "center" }}>{subTitle}</p>
          </IonText>
        </>
      )}
    </div>
  );
};

export default Empty;
